import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { FilterContextProvider } from './filter-context';
import { FilterOptionSource } from '../../common/filters/types';
import { useSearchConfigContext } from '../../common/search-config-provider';
export var FilterContextProviderWithSearchConfig = function FilterContextProviderWithSearchConfig(props) {
  var _useSearchConfigConte = useSearchConfigContext(),
    confluenceSites = _useSearchConfigConte.confluenceSites;
  var mappedSites = confluenceSites.map(function (site, index) {
    return _objectSpread(_objectSpread({}, site), {}, {
      id: site.cloudId,
      isChecked: false,
      isVisible: index < 3,
      filterSource: FilterOptionSource.EXTERNAL
    });
  });
  return /*#__PURE__*/React.createElement(FilterContextProvider, _extends({}, props, {
    defaultSiteFilters: mappedSites
  }));
};